
import { useEffect, useState } from 'react';

import EInvoiceRow from 'component/e-invoice/EInvoiceRow';
import NoData from 'component/NoData';

const EInvoiceSelection = ({items, filter, onSend}) =>
{
  const [refresh, onRefresh  ] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    setFilteredItems(getFilteredBills());
  }, [items, filter]);

  const forceRefresh = () => {
    onRefresh(!refresh);
  }

  const getFilteredBills = () =>
  {
    return items.filter(item => {
      if (filter.company && filter.company != item.company) return false;
      if (filter.district && filter.district != item.mgt_dis) return false;
      if (Number.isInteger(filter.location) && filter.location != item.srv_loc) return false;
      if (filter.cd_license && !String(item.cd_license).toUpperCase().includes(String(filter.cd_license).toUpperCase())) return false;
      if (filter.srv_plan && filter.srv_plan != item.srv_plan) return false;
      if (filter.media_type && !item['is_'+filter.media_type]) return false;
      if (filter.due_lv && filter.due_lv != item.due_lv) return false;
      return true;
    });
  }

  const selectAllFiltered = (e) => {
    getFilteredBills().forEach(item => {
      item.selected = !!e.target.checked;
    });
    forceRefresh();
  }

  const selectedCount = () => {
    return items.reduce((r,x) => r + (x.selected?1:0), 0);
  }

  const isAllFilteredSelected = () => {
    for (let item of filteredItems) {
      if (!item.selected) {
        return false;
      }
    }
    return true;
  }

  return (<div className="box e-invoice-selection">
    <h4 className="box-head">已選擇：{selectedCount()}</h4>
    <div className="box-body">
      { filteredItems?.length <= 0
      ? <NoData />
      : <table className="data-table">
          <colgroup>
            <col width="auto" id="col-einv-checkbox" />
            <col width="auto" id="col-einv-company" />
            <col width="auto" id="col-einv-location" />
            <col width="auto" id="col-einv-license" />
            <col width="auto" id="col-einv-type" />
            <col width="auto" id="col-einv-btn-email" />
            <col width="auto" id="col-einv-btn-whatsapp" />
          </colgroup>
          <thead>
            <tr>
              <th className="col-einv-checkbox">
                <input type="checkbox" checked={isAllFilteredSelected()}
                  onChange={selectAllFiltered}
                />
              </th>
              <th className="col-einv-company">公司</th>
              <th className="col-einv-location">地點</th>
              <th className="col-einv-license">車牌</th>
              <th className="col-einv-type">類型</th>
              <th className="col-einv-btn-email"></th>
              <th className="col-einv-btn-whatsapp"></th>
            </tr>
          </thead>
          <tbody>
            { filteredItems.map(item =>
              <EInvoiceRow key={`${item.company}-${item.cd_license}`}
                item={item} onChange={forceRefresh} onSend={onSend} />
            )}
          </tbody>
        </table>
      }
    </div>
  </div>);
}

export default EInvoiceSelection;
